import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as WarningIcon } from '../../../../../assets/images/warningIcon.svg';
import Button from '../../../../../components/shared/Button/Button';
import Modal from '../../../../../components/shared/Modal/Modal.jsx';
import { IsMobile } from '../../../../../helpers/IsMobile';

import styles from './CancelModal.module.scss';

const CancelModal = ({ showModal, toggleModal, handleContinue }) => {
  const { t } = useTranslation('common');
  const isMobile = IsMobile();
  return (
    <Modal
      show={showModal}
      onHide={toggleModal}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      fullscreen={isMobile}
    >
      <Modal.CustomHeader closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{t('modals.areYouSure')}</Modal.Title>
      </Modal.CustomHeader>
      <Modal.Body>
        <div className={styles.content}>
          <WarningIcon />
          <p className={styles.text}>{t('csvImport.goBackWarning')}</p>
          <p className={styles.text}>{t('csvImport.progressLost')}</p>
        </div>
      </Modal.Body>
      <Modal.CustomFooter>
        <div className={styles.btnsCont}>
          <Button variant="primary" onClick={toggleModal} className={styles.yesNoBtn}>
            {t('no')}
          </Button>
          <Button variant="outline-primary" onClick={handleContinue} className={styles.yesNoBtn}>
            {t('buttons.continue')}
          </Button>
        </div>
      </Modal.CustomFooter>
    </Modal>
  );
};

export default CancelModal;
